import { ACCOUNT_CATEGORIES, ACCOUNT_SLUGS } from '../../components/pages/AccountPage/AccountPage.consts';

export const ACCOUNT_DATE_RANGE_FILTER_ALLOWED_PAGES = {
	[ACCOUNT_CATEGORIES.SHORTLIST]: [ACCOUNT_SLUGS.ALL],
	[ACCOUNT_CATEGORIES.BIDS]: [ACCOUNT_SLUGS.DIDNT_WIN],
	[ACCOUNT_CATEGORIES.PURCHASES]: [ACCOUNT_SLUGS.COMPLETE, ACCOUNT_SLUGS.CANCELLED],
};
